import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import FormSelectFormatComponent from 'webapp/components/form/select-format';

interface Args {
	selected: string | undefined; // is empty for default format
	isDisabled: boolean;
	onChange: (value: string) => void;
	skipExampleLabels?: boolean;
}

export default class MetricEditFormatComponent extends Component<Args> {
	@service('constants') declare constantsService: Service.Constants;

	@tracked options: LabelValuePairString[] = [];

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		let options: LabelValuePairString[] = Array.from(this.constantsService.formatOptions);

		if (this.args.skipExampleLabels) {
			options = options.map((opt: LabelValuePairString) => {
				return {
					label: opt.label,
					value: opt.value,
				};
			});
		}

		if (!options.find((item) => item.value === this.selected)) {
			options.push({
				value: this.selected,
				label: this.selected,
			});
		}

		this.options = options;
	}

	get selected(): string {
		return this.args.selected || this.constantsService.defaultFormat;
	}

	get isDefaultFormatSelected(): boolean {
		return !this.args.selected;
	}

	@action
	change(value: string | null): void {
		const isDefaultFormat = value === this.constantsService.defaultFormat;
		this.args.onChange(isDefaultFormat ? '' : value!);
	}

	@action
	addCustom(value: string): void {
		const newFormat = {
			value,
			label: value,
		};
		this.options = [...this.options, newFormat];
		this.change(value);
	}
	<template>
		<FormSelectFormatComponent
			name="format"
			@placeholder="Default number format"
			@selected={{this.selected}}
			@options={{this.options}}
			@onChange={{this.change}}
			@onAdd={{this.addCustom}}
			@isDisabled={{@isDisabled}}
		/>
	</template>
}
